import React from "react";
import "./../AABI.css";

// A skeleton shaped like the rows it stands in for: name and share on the
// first line, the share bar, then value and meta. A stack of plain grey
// rectangles reads as "something is broken" — this reads as "the rows you are
// about to get", so the layout does not jump when the data lands.
const RankedListSkeleton = ({ rows = 5 }) => (
  <div className="aabi-ranked-skeleton" aria-hidden="true">
    {Array.from({ length: rows }, (_, index) => (
      <div className="aabi-ranked-skeleton-row" key={index}>
        <div className="aabi-ranked-skeleton-line">
          <span className="aabi-skeleton-block name" />
          <span className="aabi-skeleton-block share" />
        </div>
        <span className="aabi-skeleton-block bar" />
        <div className="aabi-ranked-skeleton-line">
          <span className="aabi-skeleton-block value" />
          <span className="aabi-skeleton-block meta" />
        </div>
      </div>
    ))}
  </div>
);

export default RankedListSkeleton;
